/**
 * @module app.shared
 */

import { QueryFilterGroupOperator } from './api-types';
import { encodeQueryString } from 'app/shared/lib/utilities';

export interface IApiQueryFilter {
    toString(): string;
}

export class ApiQueryFilterGroup implements IApiQueryFilter {

    public filters: IApiQueryFilter[] = [];
    public parenthesize = true;

    constructor(public operator: QueryFilterGroupOperator) {}

    public toString(): string {
        if(this.filters.length === 0) { return ''; }

        const filters: string[] = [];

        for(let filter of this.filters) {
            const value = filter.toString();
            if(value) {
                filters.push(value);
            }
        }

        if(filters.length === 0) {
            return '';
        }

        const conjunction = `+${this.operator}+`;
        return this.parenthesize ? `(${filters.join(conjunction)})` : filters.join(conjunction);
    }

}

export class ApiQueryDirectFilter implements IApiQueryFilter {

    constructor(public filter: string) {}

    public toString(): string {
        return encodeQueryString(this.filter);
    }

}

export class ApiQueryNotFilter implements IApiQueryFilter {

    constructor(public predicate: ApiQueryFilterGroup) {}

    public toString(): string {
        return `not(${this.predicate.toString()})`;
    }

}
